import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";
import React from "react";

const QuotationIcon = createSvgIcon(
  <>
    <path d="M1.46891 14H5.87564L8.81345 8.4V0H0V8.4H4.40673L1.46891 14ZM13.2202 14H17.6269L20.5647 8.4V0H11.7513V8.4H16.158L13.2202 14Z" />
  </>,
  "QuotationIcon"
);

export default QuotationIcon;
